import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import ro from 'vuetify/es5/locale/ro'
import Scroll from 'vuetify/es5/directives/scroll'

Vue.use(Vuetify, {
  theme: {
    primary: '#0e9b3a',
    accent: '#de4336',
    secondary: '#673ab7',
    error: '#FF1744',
    warning: '#ff9800',
    info: '#03a9f4',
    success: '#4caf50'
  },
  options: {
    customProperties: true
  },
  iconfont: 'mdi',
  lang: {
    locales: { ro },
    current: 'ro'
  },
  directives: {
    Scroll
  }
})
